import { CreditCardIcon, HandbagIcon } from '@phosphor-icons/react'

import { GiftCardIcon, refundMethods } from '@reveni-io/reveni-ui'

export const refundMethodsOptions = {
  [refundMethods.originalPaymentMethod]: {
    label: 'Método de pago original',
    Icon: CreditCardIcon,
  },
  [refundMethods.storeCredit]: {
    label: 'Crédito de tienda',
    Icon: HandbagIcon,
  },
  [refundMethods.giftCard]: {
    label: 'Tarjeta regalo',
    Icon: GiftCardIcon,
  },
}

export const extraValueTypes = {
  percentage: 'percentage',
  fixedAmount: 'fixed_amount',
}
